<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.select.typevehicle.label') }}
                        </label>
                        <select v-model="truckType" class="form-control" @change="findTruck()">
                            <option :value="null" selected>{{ $t('string.msg.select.typevehicle.placeholder') }}</option>
                            <option value="TRUCK">{{ $t('string.msg.truck.label.type.truck') }}</option>
                            <option value="TRUCK_TRAILER">{{ $t('string.msg.truck.label.type.trucktrailer') }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.parts.orders.fleet.service.label') }}
                        </label>
                        <select v-model="data.service" class="form-control">
                            <option :value="null" selected>{{ $t('string.msg.select.typevehicle.placeholder') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in services">{{ camelize(item.name) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.request.description.title') }}
                        </label>
                        <input type="text" v-model="data.description" class="form-control" :placeholder="$t('string.msg.company.placeholder.description')" />
                    </div>
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            {{ $t('string.msg.connect.truck.register.trucker') }}
                        </label>
                        <select v-model="data.trucker" class="form-control" @change="getUserGeolocation()">
                            <option :value="null" selected>{{ $t('string.msg.connect.truck.placeholder.register.trucker') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in truckers">{{ camelize(item.firstName) + ' ' + camelize(item.lastName) }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-row" v-if="data.trucker && truckType">
                    <div class="form-group col-md-6">
                        <label class="col-form-label">
                            <code class="highlighter-rouge">*</code>
                            <span v-if="truckType == 'TRUCK'">{{ $t('string.msg.connect.truck.placeholder.register.trucks') }}</span>
                            <span v-else-if="truckType == 'TRUCK_TRAILER'">{{ $t('string.msg.connect.truck.placeholder.register.trucks.trailer') }}</span>
                        </label>
                        <select v-model="data.truck" class="form-control">
                            <option :value="null" selected>{{ $t('string.msg.placeholder.select') }}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in trucks">
                                <span>{{ item.plate ? toUpperCase(item.plate) + ' - ' : '' }}</span>
                                <span>{{ item.vehicleType ? $t(item.vehicleType) : '' }}</span>
                                <span>{{ item.groupType ? ' - ' + toUpperCase(item.groupType) : '' }}</span>
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-row">
                    <label class="col-form-label">
                        <code class="highlighter-rouge">*</code>
                        {{ $t('string.msg.request.search.radius.label') }}
                    </label>
                    <div class="form-group col-md-12">
                        <range-slider class="slider" min="0" max="50" step="1" v-model="searchArea"> </range-slider>
                        <label> {{ searchArea }}</label
                        >&nbsp;
                        <label>
                            <strong>{{ $t('string.msg.km.label') }}</strong></label
                        >
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="inputAddress" class="col-form-label">
                            {{ $t('string.msg.company.label.address') }}
                        </label>
                        <vue-google-autocomplete ref="address" id="map" v-model="data.locale.address" classname="form-control" placeholder="Digite o endereço" v-on:placechanged="getAddressData()">
                        </vue-google-autocomplete>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputAddress" class="col-form-label">
                            {{ $t('string.msg.company.geolocation.lat') }}
                        </label>
                        <input v-model="data.locale.geolocation.latitude" type="text" class="form-control" :placeholder="$t('string.msg.company.geolocation.lat')" />
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputAddress" class="col-form-label">
                            {{ $t('string.msg.company.geolocation.lng') }}
                        </label>
                        <input v-model="data.locale.geolocation.longitude" type="text" class="form-control" :placeholder="$t('string.msg.company.geolocation.lng')" />
                    </div>
                </div>

                <div v-if="errors.length" class="alert alert-danger">
                    <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                    <ul>
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6 text-center">
                        <button @click="clearForm" class="btn btn-secondary w-50">{{ $t('string.msg.form.btn.clear') }}</button>
                    </div>
                    <div class="form-group col-md-6 text-center">
                        <button @click="checkForm" class="btn btn-success w-50">{{ $t('string.msg.form.btn.search') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <FlashMessage />
    </div>
</template>

<script>
import Spinner from '../../../../components/layout/Spinner'
import Toast from '../../../../components/layout/Toast'
import Controller from './CrtService'
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
const mapMarker = require('../../../../../public/assets/images/marker_maps.png')

export default {
    name: 'Services',
    props: ['valuekey', 'truckers', 'company'],
    watch: {
        valuekey() {},
        truckers() {
            this.truckers = this.truckers
        },
        company() {
            this.company = this.company
        },
    },
    components: {
        Spinner,
        Toast,
        RangeSlider,
        VueGoogleAutocomplete,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            trucks: null,
            messageToast: null,
            messageIdToast: null,
            companies: [],
            items: [],
            sliderValue: 0,
            searchArea: 0,
            truckType: null,
            address: {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null,
            },
            addresses: [],
            markerOptions: {
                url: mapMarker,
                size: { width: 80, height: 90, f: 'px', b: 'px' },
                scaledSize: { width: 45, height: 60, f: 'px', b: 'px' },
            },
            data: {
                searchArea: 0,
                truck: null,
                manufacturer: null,
                family: null,
                systemUser: null,
                trucker: null,
                description: null,
                typeOrder: 'SERVICES',
                latitude: 0,
                longitude: 0,
                statusOrder: 'WAITING_FOR_RESPONSE',
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
            },
            filters: {
                vehicleTypes: [],
                status: 'ACTIVE',
            },
            truckTypes: [
                'TRUCKTRAILER_CONVENCIONAL',
                'TRUCKTRAILER_DOLLY',
                'TRUCKTRAILER_VANDERLEIA',
                'TRUCKTRAILER_BITREM',
                'TRUCKTRAILER_RODOTREM',
                'TRUCK_VUC',
                'TRUCK_TOCO',
                'TRUCK_TRUCK',
                'TRUCK_MECHANICAL_HORSE_SIMPLE',
                'TRUCK_MECHANICAL_HORSE_TRUCADO',
                'TRUCK_MECHANICAL_HORSE_TRACADO',
                'TRUCK_DOUBLE_TRAIN',
                'TRUCK_RODOTREM',
            ],
        }
    },
    methods: Controller.methods,
    created() {},
    mounted() {
        Controller.init(this)
    },
}
</script>
<style>
.slider {
    /* overwrite slider styles */
    width: 300px;
}
</style> 